<h1>Homologar relatório de atividades</h1>

<mat-card>
  <mat-card-content fxLayout="column" fxLayoutGap="20px">
    <fieldset fxFlex="100%">
      <legend>Aluno</legend>
      <form [formGroup]="form" fxLayout="column" fxLayoutGap="5px">
        <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
          <mat-form-field appearance="outline">
            <mat-label>Nome</mat-label>
            <input matInput value="{{ relatorio?.nome }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>CPF</mat-label>
            <input matInput value="{{ relatorio?.cpf }}" readonly="readonly" />
          </mat-form-field>
        </div>

        <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
          <mat-form-field appearance="outline">
            <mat-label>Programa</mat-label>
            <input matInput value="{{ relatorio?.programa }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Curso</mat-label>
            <input matInput value="{{ relatorio?.curso }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Unidade</mat-label>
            <input matInput value="{{ relatorio?.campus }}" readonly="readonly" />
          </mat-form-field>
        </div>
      </form>
    </fieldset>

    <fieldset fxFlex="100%">
      <legend>Disciplina</legend>
      <form [formGroup]="form" fxLayout="column" fxLayoutGap="5px">
        <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
          <mat-form-field appearance="outline">
            <mat-label>Disciplina</mat-label>
            <input matInput value="{{ relatorio?.nomeDisciplina }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Código</mat-label>
            <input matInput value="{{ relatorio?.codigoDisciplina }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Semestre</mat-label>
            <input matInput value="{{ relatorio?.semestre }}" readonly="readonly" />
          </mat-form-field>
        </div>

        <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
          <mat-form-field appearance="outline">
            <mat-label>Duração</mat-label>
            <input matInput value="{{ relatorio?.duracao }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Carga horária</mat-label>
            <input matInput value="{{ relatorio?.cargaHoraria }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Departamento</mat-label>
            <input matInput value="{{ relatorio?.departamentoDisciplina }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Unidade</mat-label>
            <input
              matInput
              value="{{ relatorio?.campusDisciplina }} - {{ relatorio?.siglaDisciplina }}"
              readonly="readonly" />
          </mat-form-field>
        </div>
      </form>
    </fieldset>

    <fieldset fxFlex="100%">
      <legend>Relatório de atividades</legend>
      <form [formGroup]="form" fxLayout="column" fxLayoutGap="5px">
        <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
          <div class="w100">
            <div class="w100-p14">
              <a class="w100-p7" mat-stroked-button (click)="download(relatorio)"
                ><mat-icon>file_download</mat-icon> Visualizar</a
              >
            </div>
          </div>
          <mat-form-field appearance="outline">
            <mat-label>Situação</mat-label>
            <mat-select formControlName="aprovado" (selectionChange)="alteraSituacao($event)">
              <mat-option value="">Aguardando homologação</mat-option>
              <mat-option value="hom">Homologado</mat-option>
              <mat-option value="rep">Não homologado</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline" *ngIf="form.controls['aprovado'].value === 'rep'">
          <mat-label>Motivo</mat-label>
          <textarea matInput formControlName="motivo" rows="3"></textarea>
        </mat-form-field>
        @if (relatorio?.anoReferencia! >= 2025) {
          <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
            <mat-form-field appearance="outline">
              <mat-label>Data inicial da participação do discente</mat-label>
              <input matInput value="{{ relatorio?.dataInicialAtividadesDiscente | date: 'dd/MM/yyyy' }}" readonly="readonly" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Data final da participação do discente</mat-label>
              <input matInput value="{{ relatorio?.dataFinalAtividadesDiscente | date: 'dd/MM/yyyy' }}" readonly="readonly" />
            </mat-form-field>
          </div>
        }
      </form>
    </fieldset>
  </mat-card-content>
  <mat-card-actions>
    <div fxLayoutAlign="space-between center">
      <button mat-raised-button color="primary" (click)="gravar()"><mat-icon>save</mat-icon> Gravar</button>
      <button mat-stroked-button color="warn" routerLink="/departamento/homologar-relatorio">
        <mat-icon>close</mat-icon> Cancelar
      </button>
    </div>
  </mat-card-actions>
</mat-card>
